import React from "react";

interface StickFigureProps {
    color?: string;
    style?: React.CSSProperties;
}

export const StickFigure: React.FC<StickFigureProps> = ({ color = "#374151", style }: StickFigureProps) => {
    return (
        <svg width="80" height="100" viewBox="0 0 100 120" className="stick-figure">
            {/* Head */}
            <circle cx="50" cy="20" r="10" fill="none" stroke={color} strokeWidth="2" />
            {/* Body */}
            <line x1="50" y1="30" x2="50" y2="70" stroke={color} strokeWidth="2" />
            {/* Left arm */}
            <line x1="50" y1="40" x2="30" y2="50" stroke={color} strokeWidth="2" />
            {/* Right arm */}
            <line x1="50" y1="40" x2="70" y2="50" stroke={color} strokeWidth="2" />
            {/* Left leg */}
            <line x1="50" y1="70" x2="35" y2="100" stroke={color} strokeWidth="2" />
            {/* Right leg */}
            <line x1="50" y1="70" x2="65" y2="100" stroke={color} strokeWidth="2" />
        </svg>
    );
}

export const Arrow: React.FC<StickFigureProps> = ({ color = "#374151", style }: StickFigureProps) => {
    return (
        <svg width="20" height="15" viewBox="0 0 30 15" style={{ margin: '0 5px' }}>
            <line x1="0" y1="7.5" x2="15" y2="7.5" stroke={color} strokeWidth="2" />
            <polygon points="15,7.5 10,2.5 10,12.5" fill={color} />
        </svg>
    );
}